<template>
    <div class="tg-swipertabbar clearfix" :class="rsTheme" v-show="showStatus">
        <span class="paddingr20 first float-left" @click="loadContent(data[0],-1)" :class="{'active':activeIndex==-1}" style="width:2rem" :data-scp="data[0].scpCD">{{data[0].title}}</span>
        <cmui-slider :col="0" :items="data.slice(1)" :theme="4" class="float-left" style="width:8rem">
            <cmui-slider-item v-for="item in data.slice(1)" @click="loadContent(item,$index)" :class="{'active':$index==activeIndex}" :data-scp="item.scpCD">
                <span>{{item.title}}</span>
            </cmui-slider-item>
        </cmui-slider>
    </div>
</template>
<style lang="scss">
    .tg-swipertabbar.theme_1 .swiper-slide,.tg-swipertabbar.theme_1 .first{
        padding:0.166666667rem;
    }
    .tg-swipertabbar.theme_1 .swiper-slide.active{
        color:#16bb80;
    }
    .tg-swipertabbar.theme_1{
        font-size: 13px;
        color:#666;
    }
</style>
<script>
import _ from '_';
export default {
	props:{
		data:Array,
        target:{
            type:Object,
            default:{}
        },
        theme:{
            type:Number,
            default:"1"
        },
        tabIndexName:{
            type:String,
            default:'TGTabIndex'
        }
	},
	computed:{
		showStatus:function(){
			return !!this.data.length
		},
        rsTheme:function(){
            return 'theme_'+this.theme;
        }
	},
    data(){
        var _this=this;
        return {
            activeIndex:(function(){
                if(maple.url().params[_this.tabIndexName]!==undefined){
                    return maple.url().params[_this.tabIndexName]
                }else{
                    return -1
                }
            })(),
            nowParams:''
        }
    },
    ready:function(){
        if(!this.$el.id){
            this.$el.id=_.uniqueId('tgTabbar_');
        }
        this.$dispatch('initTabComponent',this.target,this.activeIndex);
    },
    methods:{
        loadContent(item,index){
            var tgTabBarParams=maple.url().params.tgTabBarParams;
            if(tgTabBarParams){
                tgTabBarParams=JSON.parse(unescape(tgTabBarParams))
            }
            if(_.includes(item.params,'=')){
                var o={};
                o[item.params.split('=')[0]]=item.params.split('=')[1]
                tgTabBarParams=_.defaults(o,tgTabBarParams)
            }
            if(this.activeIndex==index){
                return
            }
            this.activeIndex=index;
            let np={tgTabBarParams:JSON.stringify(tgTabBarParams)};
            np[this.tabIndexName]=index;
            // !maple.device.weixin && maple.url().replace(np); 
            this.nowParams=_.get(item,'params');
            this.$dispatch('loadswiperTabComponent',item,this.target);
        }
    }
    , watch: {
        data: function(newVal){
            if( !newVal || !newVal.length ){
                this.activeIndex = -1;
            }
        }
    }
}
</script>